import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TFullUserApi, TMediumUserApi } from './userApi.types'

export const userApi = {
  getUser: (userId: number, { signal }: TSignalConfig) => fetcher.query<TMediumUserApi>(`/user/${userId}`, { signal }),
  getUserByUpdateParametersToken: (updateParametersToken: string, { signal }: TSignalConfig) =>
    fetcher.query<TFullUserApi>(`/user/update-parameters-token/${updateParametersToken}`, { signal }),
  getConversationWithUser: (userId: number, { signal }: TSignalConfig) =>
    fetcher.query<number | null>(`/users/${userId}/conversation`, { signal }),
}
